import {
  createReducer,
  createActionResources,
  createActionCRUDResources,
} from "redux-waiters";
import { RESET_REDUCER } from "../constants";

export const orderActions = createActionCRUDResources("orders");
export const getOrderAction = createActionResources("orders/get-order");
export const userOrderAction = createActionResources("orders/user");
export const recloneAction = createActionResources("orders/re-clone");
export const fetchOrdersAction = createActionResources("orders/fetch-orders");

const initialState = {
  fetching: false,
  list: [],
  total: 0,
  totalPages: 0,
  pageNumber: 1,
  error: {},
};

export default createReducer(
  {
    [orderActions.fetch.start]: state => {
      return { ...state, fetching: true };
    },
    [orderActions.fetch.success]: (state, action) => {
      return {
        ...state,
        list: action.data?.content,
        pageNumber: action.data?.pageNumber + 1,
        total: action.data?.total,
        totalPages: Math.ceil(action.data?.total / action.data?.pageSize),
        fetching: false,
      };
    },
    [orderActions.fetch.error]: state => {
      return { ...state, fetching: false };
    },

    [RESET_REDUCER]: () => initialState,
  },
  initialState
);
